import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ConfirmationDialogComponent } from './../confirmation-dialog/confirmation-dialog.component';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { AppComponent } from './../../app.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ExcelService } from './../../services/excel.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SharedService } from './../../services/sharedService/shared.service';
import * as saveAs from 'file-saver';
import { LoggerService } from 'src/app/services/logger.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Store } from '@ngrx/store';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css'],
  providers: [DatePipe]

})
export class InvoicesComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  persons: Array<any> = [];

  loader: boolean
  dtTrigger: Subject<any> = new Subject<any>();
  members: Array<any> = [];
  filterStatus: any[];
  brokerstatus: any;
  customerid: any;
  getCustomerDraftDetails: any;
  getCustomerDraftDate: any;
  customerInvoices: any;
  invoiceslink: any;
  showViewPlansLoading: boolean = true;
  showtabledata = false;
  bsConfig: Partial<BsDatepickerConfig>;
  dateRange: Date[];
  dateSelection: Date | Date[];
  isRange: boolean = false;
  selectedFilter = 'all';
  minDateForPicker: any;
  maxDateForPicker: Date;
  filterForm: FormGroup = new FormGroup({
    monthRangeEnabled: new FormControl(''),
    dateSelection: new FormControl(''),
    invoiceCategory: new FormControl(''),
    planCategory: new FormControl('')

  });
  invoiceCategories: any[]
  planCategories: any[]
  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;
  dropdownSettings: any;
  multiSelectCustomers: Array<any> = [];
  viewDraftInvoice: boolean;
  viewInvoice: boolean;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();

  constructor(private logger: LoggerService, private formBuilder: FormBuilder,
    private formBuilderDetails: FormBuilder,
    private SharedService: SharedService,
    private http: HttpClient, 
    public router: Router, 
    private datePipe: DatePipe, 
    private excelService: ExcelService,
    private store: Store<{ languageData: [] }>
  ) {
    this.languageData$ = store.select(selectLanguageData);
   }

  ngOnInit(): void {
this.getLanguageTokens()
    this.viewDraftInvoice = false;
    this.viewInvoice = false;
    this.loader = false;

    this.initializeDateRange()
    this.invoiceCategories = ["All", "Corporate", "GIG", "TPA", "GroupBenefitz", "Waddel"]
    this.planCategories = [{ id: 1, name: "ClassicBronze" }, { id: 2, name: "ClassicSilver" }],
      this.dropdownSettings = {
        singleSelection: false,
        closeDropDownOnSelection: true,
        idField: 'id',
        textField: `fullName`,
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        itemsShowLimit: 2,
        allowSearchFilter: true,
      };
    this.filterForm = this.formBuilder.group({
      monthRangeEnabled: [false],
      dateSelection: [''],
      invoiceCategory: ['All'],
      planCategory: ['']
    });

    // this.setPickerMode(this.isRange);

  }

  public getLanguageTokens(){
    // let body= {
    //   "project":"Admin Portal",
    //   "url":"Invoices"
    // }
    // this.http
    // .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    // .subscribe(
    //   (response: any) => {
    //     console.log(response)
    //     this.lang = {};
    //     // this.languageData = response.strings
    //     this.selectedLanguage = sessionStorage.getItem("language")
    //     for (let token of response.strings) {
    //       this.lang[token.key] = token[this.selectedLanguage];
    //     }
    //     console.log(this.lang)
    //   })

    // this.store.dispatch(loadLanguageData());
    
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })
  }
  initializeDateRange() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    this.minDateForPicker = new Date(currentYear - 1, 0);
    this.maxDateForPicker = new Date(currentYear, currentMonth + 1)
    // this.dateRange = [new Date(currentYear - 1, 0), new Date(currentYear, currentMonth + 1)];
    // this.mindate=
  }
  initializeFilters() {
    this.filterForm = this.formBuilder.group({
      monthRangeEnabled: [false],
      dateSelection: [''],
      invoiceCategory: ['All'],
      planCategory: ['']
    });
  }

  toggleMonthRange() {
    this.filterForm.get('dateSelection').setValue('')
  }

  // setPickerMode(isRange: boolean): void {
  //   this.bsConfig = {
  //     dateInputFormat: 'MM/YYYY',
  //     minMode: 'month',
  //     rangeInputFormat: 'MM/YYYY',
  //     selectFromOtherMonth: true,
  //     showWeekNumbers: false
  //   };
  //   // if (isRange) {
  //   //   this.bsConfig.rangeSelector = true;
  //   // } else {
  //   //   this.bsConfig.rangeSelector = false;
  //   // }
  // }

  toggleMode(): void {
    this.isRange = !this.isRange;
    this.dateSelection = undefined;
  }

  resetFilters() {
    this.initializeDateRange();
    this.filterForm.reset()
    this.initializeFilters()
  }


  applyFilters() {
    console.log(this.filterForm.controls)
    this.getclientList()
  }


  closemultiSelectProvianceSelectDropdown() {
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
  }
  memberSelect(event: any) {
    this.logger.log(event);
    this.multiSelectCustomers.push(event.id);
    //   this.multiSelectProviancenames.push(event)
    //   this.logger.log(this.multiSelectProviancenames);
    // }
  }
  membersSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectCustomers = [];
    event.forEach((proviance: any) => {
      this.multiSelectCustomers.push(proviance.id);
    });
    this.logger.log(this.multiSelectCustomers);
    this.closemultiSelectProvianceSelectDropdown();
  }


  memberDeSelect(event: any) {
    this.logger.log(event);
    let indexOf = this.multiSelectCustomers.indexOf(event.id);
    this.multiSelectCustomers.splice(indexOf, 1);
    this.logger.log(this.multiSelectCustomers);

  }
  memberDeSelectAll(event: any) {
    this.logger.log(event);
    this.multiSelectCustomers = [];
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  public getclientList() {

    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/customers/list

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var getClients = '/api/ap/admin/customers/list';
    const that = this;
    this.http
      .get(environment.apiUrl + getClients, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {

          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.members = (response as any).data;
            this.filterStatus = [];
            this.members.map((member) => {
              if (!this.filterStatus.includes(member.status))
                this.filterStatus.push(member.status);
            });
            this.logger.log("status", this.filterStatus);
            this.members.sort((a, b) => {
              const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

              if (order[a.status] !== order[b.status]) {
                return order[a.status] - order[b.status];
              }
              // return a.firstName.localeCompare(b.firstName);
              const result = a.firstName.localeCompare(b.firstName);
              return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
            });
            this.members = this.members.map(user => ({
              ...user,
              fullName: user.firstName + ' ' + user.lastName
            }));

            this.loader = false
          } else {
            this.loader = false
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          this.loader = false
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  public getInvoices() {

    this.customerid = this.multiSelectCustomers[0]
    console.log(this.customerid, this.multiSelectCustomers[0]) //change to array of customers after getting api
    this.getCustomerDraftData()
    this.getCustomerData()

  }

  getCustomerDraftData() {
    var accessToken = sessionStorage.getItem('accessToken');

    let customerDataEndpoint = '/' + this.customerid + '/invoices';
    this.http.post(environment.apiUrl + '/api/ap' + customerDataEndpoint, {}, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.getCustomerDraftDetails = response.data.invoice
        this.getCustomerDraftDate = response.data.date

        if (this.getCustomerDraftDate) {
          this.showtabledata = true
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang.Error??'Error', text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang.Error??'Error', text: error.error.error.message })
    });
  }

  getCustomerData() {
    var accessToken = sessionStorage.getItem('accessToken');

    let customerDataEndpoint = '/customer/' + this.customerid + '/details';
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {


        this.customerInvoices = response.data.invoices




      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang.Error??'Error', text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang.Error??'Error', text: error.error.error.message })
    });
  }

  showdraftinvoice() {
    this.viewDraftInvoice = true
    this.viewInvoice = false
  }

  viewinvoices(value: any) {
    // $('#viewinvoice').modal('show');
    this.invoiceslink = value;
    this.viewInvoice = true;
    this.viewDraftInvoice = false;
    this.logger.log(this.invoiceslink)

  }

  viewPlansLoading(e: any) {
    this.showViewPlansLoading = false;
  }

  downloadinvoices(value: any) {
    this.http.get(value.file, { responseType: "arraybuffer" }).subscribe(
      pdf => {
        const blob = new Blob([pdf], { type: "application/pdf" });
        const fileName = "Invoice" + ".pdf";
        saveAs(blob, fileName);
      },
      (error) => {
        Swal.fire({ allowOutsideClick: false, title: this.lang.Error??'Error', text: error.error.error.message })
      }
    );
  }

  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
